import { withSentry } from '../../modules/sentry';
import $dom from 'cash-dom';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import { globalEventBusPlugin } from '@pixelcabin/ui-utils/lib/vue';
import collectionFilter from '../../modules/collection_filter';
import collectionSortOptions from '../../modules/collection_sort_options';

import AccessoriesAddToCart from '../../components/AccessoriesAddToCart/AccessoriesAddToCart.vue';

$dom.fn.ready(
  withSentry(() => {
    console.log('init accessories scripts');

    if (['ibc', 'myflavia'].includes(__SHOPIFY_ENV__)) {
      collectionFilter();
      collectionSortOptions();
    }

    Vue.use(vueCustomElement);
    Vue.use(globalEventBusPlugin);
    Vue.customElement('pxl-accessories-purchase-form', AccessoriesAddToCart);
  })
);
